import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import DocumentTemplateEditor from "../../editors/masterdata/documentTemplate";

const DocumentTemplates: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.DocumentTemplatesList}
			endpoint={Endpoint.DocumentTemplates}
			addScreen={{ screen: DocumentTemplateEditor, isAllowed: hasPermission(Permission.DocumentTemplatesAdd) }}
			editScreen={{ screen: DocumentTemplateEditor, isAllowed: hasPermission(Permission.DocumentTemplatesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.DocumentTemplatesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default DocumentTemplates;
